import React, { useState, useEffect } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/Verify2fa/Index";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
import ApiCall from "../common/ApiCall";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { set2faVerified, setLoading, setLogin } from "../redux/user/user.action";
import { handoffToSupport } from "../common/supportHandoff";

export default function Verify2faController() {

    const [state, setState] = useState({
        otp: "",
        error: [],
    })
    const { otp } = state;




    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const isWelcomePageEnabled = user.isWelcomePageEnabled;


    const changeValue = (e) => {
        let value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        setState({
            ...state,
            [e.target.name]: numericValue
        })

        if (numericValue.length === 6) {
            verify(e, numericValue.trim());
        }
    }

    const handlePaste = (e) => {
        const pastedValue = e.clipboardData.getData('text');
        setState({
            ...state,
            otp: pastedValue
        })
        verify(e, pastedValue.trim())


    };

    const handlePasteButtonClick = async (e) => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            setState({
                ...state,
                otp: clipboardText
            })

            verify(e, clipboardText.trim())

        } catch (err) {

        }
    };

    const verify = (e, code = null) => {

        e?.preventDefault();

        const rules = {
            otp: 'required|min:6|max:6',

        }
        let stateData = {
            otp: String(code) ?? String(otp)
        }

        const message = {
            'otp.required': 'code is Required.',
            'otp.min': 'The code must be exactly 6 characters long',
            'otp.max': 'The code must be exactly 6 characters long',
        }

        validateAll(stateData, rules, message).then(async () => {
            dispatch(setLoading(true))
            const formaerrror = {};

            let data = {}
            data.code = stateData.otp
            data.user_id = user?.userDetails?.id


            const verifyOtp = await ApiCall('post', 'verify-2fa', data)

            if (verifyOtp) {
                dispatch(setLoading(false))
                if (verifyOtp.data.success) {

                    let dispatchData = {}
                    dispatchData.userDetails = verifyOtp.data.user
                    dispatchData.token = verifyOtp.data.access_token
                    dispatchData.tempEmail = verifyOtp.data.user.email
                    dispatchData.supplierDetails = verifyOtp.data.supplier
                    dispatchData.is2faEnabled = verifyOtp.data.user?.is_2fa_enabled
                    dispatchData.permissions = verifyOtp.data.user?.permissions

                    dispatch(setLogin(dispatchData))
                    dispatch(set2faVerified(true))

                    ToastAlert({ msg: verifyOtp.data?.message, msgType: 'success' });

                    // Came from support → hand off there instead of the dashboard.
                    if (sessionStorage.getItem('supportRedirect') === '1') {
                        sessionStorage.removeItem('supportRedirect');
                        const ok = await handoffToSupport(verifyOtp.data.access_token);
                        if (ok) return; // browser is navigating to support
                    }

                    // navigate('/dashboard')
                    const redirectTo =
                        sessionStorage.getItem("postLoginRedirect") || (isWelcomePageEnabled ? "/information" : "/dashboard");

                    sessionStorage.removeItem("postLoginRedirect");
                    navigate(redirectTo, { replace: true });

                } else {

                    if (verifyOtp.data?.errors && Object.keys(verifyOtp.data.errors).length) {

                        setState({
                            ...state,
                            error: verifyOtp.data.errors,
                        })

                    } else {
                        const formaerrror = {};
                        formaerrror.otp = verifyOtp.data.message
                        setState({
                            ...state,
                            error: formaerrror,
                            otp: stateData.otp
                        })
                        // ToastAlert({ msg: verifyOtp.data.message, msgType: 'error' });
                    }
                }
            } else {
                dispatch(setLoading(false))
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }



        }).catch(errors => {
            dispatch(setLoading(false))
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }

            setState({
                ...state,
                error: formaerrror,
                otp: stateData.otp
            })

        });

    }


    return (
        <>
            <PageTitle title={'Verify 2fa'} />
            <Index
                verify={verify}
                state={state}
                changeValue={changeValue}
                handlePaste={handlePaste}
                handlePasteButtonClick={handlePasteButtonClick}
            />
        </>
    )

}